/* DO NOT EDIT THIS FILE BY HAND!
 * This file is auto-generated by a script, generate-market-colors.ts.
 * To re-generate this file, run the following in the kyoko directory
 *
 * $> yarn generate
 */
// spell-checker: disable

import { Logo as $24exchange } from './24exchange';
import { Logo as $alameda } from './alameda';
import { Logo as $b2c2 } from './b2c2';
import { Logo as $binance } from './binance';
import { Logo as $bitfinex } from './bitfinex';
import { Logo as $bitmex } from './bitmex';
import { Logo as $bitstamp } from './bitstamp';
import { Logo as $bittrex } from './bittrex';
import { Logo as $coinbase } from './coinbase';
import { Logo as $coinMetrics } from './coinMetrics';
import { Logo as $copper } from './copper';
import { Logo as $cumberland } from './cumberland';
import { Logo as $dvChain } from './dvChain';
import { Logo as $enigma } from './enigma';
import { Logo as $erisx } from './erisx';
import { Logo as $fireblocks } from './fireblocks';
import { Logo as $flowTraders } from './flowTraders';
import { Logo as $ftx } from './ftx';
import { Logo as $galaxy } from './galaxy';
import { Logo as $gemini } from './gemini';
import { Logo as $genesis } from './genesis';
import { Logo as $hehmeyer } from './hehmeyer';
import { Logo as $itbit } from './itbit';
import { Logo as $janeStreet } from './janeStreet';
import { Logo as $kalshi } from './kalshi';
import { Logo as $kraken } from './kraken';
import { Logo as $lmax } from './lmax';
import { Logo as $nydig } from './nydig';
import { Logo as $okcoin } from './okcoin';
import { Logo as $okex } from './okex';
import { Logo as $osl } from './osl';
import { Logo as $poloniex } from './poloniex';
import { Logo as $polymarket } from './polymarket';
import { Logo as $silvergate } from './silvergate';
import { Logo as $sucden } from './sucden';
import { Logo as $uniswapTrading } from './uniswapTrading';
import { Logo as $virtu } from './virtu';
import { Logo as $whalefin } from './whalefin';
import { Logo as $wintermute } from './wintermute';

export const marketLogoLookup = {
  'YWxhbWVkYQ==': $alameda, // alameda
  'YjJjMg==': $b2c2, // b2c2
  'YmluYW5jZQ==': $binance, // binance
  YmluYW5jZV9mdXR1cmVz: $binance, // binance_futures
  'YmluYW5jZV91cw==': $binance, // binance_us
  'Yml0ZmluZXg=': $bitfinex, // bitfinex
  Yml0bWV4: $bitmex, // bitmex
  'Yml0c3RhbXA=': $bitstamp, // bitstamp
  'Yml0dHJleA==': $bittrex, // bittrex
  'Y29pbmJhc2U=': $coinbase, // coinbase
  Y29pbl9tZXRyaWNz: $coinMetrics, // coin_metrics
  Y29wcGVy: $copper, // copper
  'Y3VtYmVybGFuZA==': $cumberland, // cumberland
  'ZHZjaGFpbg==': $dvChain, // dvchain
  ZW5pZ21h: $enigma, // enigma
  'MjRfZXhjaGFuZ2U=': $24exchange, // 24_exchange
  'ZXJpc3g=': $erisx, // erisx
  'ZXJpc3hfZnV0dXJlcw==': $erisx, // erisx_futures
  'ZmlyZWJsb2Nrcw==': $fireblocks, // fireblocks
  'Zmxvd3RyYWRlcnM=': $flowTraders, // flowtraders
  ZnR4: $ftx, // ftx
  'ZnR4X290Yw==': $ftx, // ftx_otc
  ZnR4X3Vz: $ftx, // ftx_us
  Z2FsYXh5: $galaxy, // galaxy
  Z2VtaW5p: $gemini, // gemini
  'Z2VuZXNpcw==': $genesis, // genesis
  'aGVobWV5ZXI=': $hehmeyer, // hehmeyer
  'aXRiaXQ=': $itbit, // itbit
  'amFuZXN0cmVldA==': $janeStreet, // janestreet
  a2Fsc2hp: $kalshi, // kalshi
  a3Jha2Vu: $kraken, // kraken
  bG1heF9kaWdpdGFs: $lmax, // lmax_digital
  'bG1heF9sb25kb24=': $lmax, // lmax_london
  'bnlkaWc=': $nydig, // nydig
  b2tjb2lu: $okcoin, // okcoin
  'b2tleA==': $okex, // okex
  b3Ns: $osl, // osl
  b3NsX2Ft: $osl, // osl_am
  'cG9sb25pZXg=': $poloniex, // poloniex
  'cG9seW1hcmtldA==': $polymarket, // polymarket
  'c2lsdmVyZ2F0ZQ==': $silvergate, // silvergate
  c3VjZGVu: $sucden, // sucden
  dW5pc3dhcF90cmFkaW5n: $uniswapTrading, // uniswap_trading
  'dmlydHU=': $virtu, // virtu
  'd2hhbGVmaW4=': $whalefin, // whalefin
  'd2ludGVybXV0ZQ==': $wintermute, // wintermute
};
